import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IIapPoll } from '../IapPollsApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseIapPollQueryValues = {
  appId: string;
  iapPollId: string;
};

export const iapPollQueryKeyFactory: IQueryKeyFactory<
  IUseIapPollQueryValues
> = (values) =>
  values && (['iapPoll', values.appId, values.iapPollId] as const);

export const useIapPollQuery = (
  values?: IUseIapPollQueryValues,
  options?: UseQueryOptions<IIapPoll, ApiError>,
): UseQueryResult<IIapPoll, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: iapPollQueryKeyFactory(values),
    queryFn: values
      ? () => api.iapPolls.get(values.appId, values.iapPollId)
      : undefined,
    enabled: !!values,
    ...options,
  });
};
